import React from "react";
import { Button, Typography, Grid } from "@mui/material";
import CalculateIcon from "@mui/icons-material/Calculate";
import { EuroField } from "./EuroField";

export default function FinancialnaOngeval(props) {

    const saldibalans = props.saldibalans;
    const updateSaldibalans = props.updateSaldibalans;
    const verwachting = props.verwachting;
    const updateVerwachting = props.updateVerwachting;
    const opgeteld = props.opgeteld;
    const betrokkene = props.betrokkene;
    const calculateRekendeelOpgeteld = props.calculateRekendeelOpgeteld;
    const calculateRekendeelSaldibalans = props.calculateRekendeelSaldibalans;

    return (
        <div>
            <Grid container spacing={2}>

                {/* ── Saldibalans ── */}
                <Grid item xs={4}>
                    <Typography style={{ padding: 10 }}>Saldibalans {betrokkene.saldibalansPeriod}</Typography><br />
                    <EuroField label="Opbrengsten" name="opbrengsten" value={saldibalans.opbrengsten} onChange={updateSaldibalans} />
                    <EuroField label="Inkoopkosten" name="inkoopkosten" value={saldibalans.inkoopkosten} onChange={updateSaldibalans} />
                    <EuroField label="Inhuur derden/Uitbesteed werk" name="inhuur" value={saldibalans.inhuur} onChange={updateSaldibalans} />
                    <EuroField label="Totale overige bedrijfskosten" name="bedrijfkosten" value={saldibalans.bedrijfkosten} onChange={updateSaldibalans} />
                    <EuroField label="Kosten vervangende arbeid" name="arbeidKosten" value={saldibalans.arbeidKosten} onChange={updateSaldibalans} />
                    <EuroField label="Afschrijvingen" name="afscrijvigen" value={saldibalans.afscrijvigen} onChange={updateSaldibalans} />
                    <EuroField label="Financiele baten en lasten" name="batenenlasten" value={saldibalans.batenenlasten} onChange={updateSaldibalans} />
                    <EuroField label="Saldo winst-en verliesrekening" name="winst" value={saldibalans.winst} disabled />
                    <EuroField label="Premies AOV/Pensioen/lijfrente" name="premie" value={saldibalans.premie} onChange={updateSaldibalans} />
                    <br />
                    <Button
                        variant="outlined"
                        disabled={!saldibalans.dataChanged}
                        endIcon={<CalculateIcon />}
                        onClick={calculateRekendeelSaldibalans}
                    >
                        Calculate
                    </Button>
                </Grid>

                {/* ── Verwachting ── */}
                <Grid item xs={4}>
                    <Typography style={{ padding: 10 }}>Verwachting {betrokkene.verwachtingPeriod}</Typography><br />
                    <EuroField label="Opbrengsten" name="opbrengsten" value={verwachting.opbrengsten} onChange={updateVerwachting} />
                    <EuroField label="Inkoopkosten" name="inkoopkosten" value={verwachting.inkoopkosten} onChange={updateVerwachting} />
                    <EuroField label="Inhuur derden/Uitbesteed werk" name="inhuur" value={verwachting.inhuur} onChange={updateVerwachting} />
                    <EuroField label="Totale overige bedrijfskosten" name="bedrijfkosten" value={verwachting.bedrijfkosten} onChange={updateVerwachting} />
                    <EuroField label="Kosten vervangende arbeid" name="arbeidKosten" value={verwachting.arbeidKosten} onChange={updateVerwachting} />
                    <EuroField label="Afschrijvingen" name="afscrijvigen" value={verwachting.afscrijvigen} onChange={updateVerwachting} />
                    <EuroField label="Financiele baten en lasten" name="batenenlasten" value={verwachting.batenenlasten} onChange={updateVerwachting} />
                    <EuroField label="Saldo winst-en verliesrekening" name="winst" value={verwachting.winst} disabled />
                    <EuroField label="Premies AOV/Pensioen/lijfrente" name="premie" value={verwachting.premie} onChange={updateVerwachting} />
                    <br />
                </Grid>

                {/* ── Opgeteld ── */}
                <Grid item xs={4}>
                    <Typography style={{ padding: 10 }}>Opgeteld</Typography><br />
                    <EuroField label="Opbrengsten" name="opbrengsten" value={opgeteld.opbrengsten} disabled />
                    <EuroField label="Inkoopkosten" name="inkoopkosten" value={opgeteld.inkoopkosten} disabled />
                    <EuroField label="Inhuur derden/Uitbesteed werk" name="inhuur" value={opgeteld.inhuur} disabled />
                    <EuroField label="Totale overige bedrijfskosten" name="bedrijfkosten" value={opgeteld.bedrijfkosten} disabled />
                    <EuroField label="Kosten vervangende arbeid" name="arbeidKosten" value={opgeteld.arbeidKosten} disabled />
                    <EuroField label="Afschrijvingen" name="afscrijvigen" value={opgeteld.afscrijvigen} disabled />
                    <EuroField label="Financiele baten en lasten" name="batenenlasten" value={opgeteld.batenenlasten} disabled />
                    <EuroField label="Saldo winst-en verliesrekening" name="winst" value={opgeteld.winst} disabled />
                    <EuroField label="Premies AOV/Pensioen/lijfrente" name="premie" value={opgeteld.premie} disabled />
                    <br />
                    <Button
                        variant="outlined"
                        disabled={!opgeteld.dataChanged}
                        endIcon={<CalculateIcon />}
                        onClick={calculateRekendeelOpgeteld}
                    >
                        Calculate
                    </Button>
                </Grid>

            </Grid>
        </div>
    );
}